module.exports = __webpack_public_path__ + "static/img/02sjksh.dba8c4b9.svg";